import { useEffect } from 'react';
/**
 * Checks if the browser's state matches the provided `mediaQuery`.
 *
 * Handles updating via the provided `callback` if the brower's state changes related to the media query.
 */ export function useMediaQuery(mediaQuery, callback) {
    useEffect(()=>{
        if (window && window.matchMedia) {
            const mql = window.matchMedia(mediaQuery);
            callback(mql.matches);
            const updateCallback = (e)=>{
                callback(e.matches);
            };
            // As usual web specs are dumb and we have two ways to add events listeners...
            // So addEventListener is correct and addListener is deprecated
            // Even TS doesn't know :)
            // @ts-ignore
            if (mql.addEventListener) {
                mql.addEventListener('change', updateCallback);
            } else if (mql.addListener) {
                mql.addListener(updateCallback);
            }
            return ()=>{
                // @ts-ignore
                if (mql.removeEventListener) {
                    mql.removeEventListener('change', updateCallback);
                } else if (mql.removeListener) {
                    mql.removeListener(updateCallback);
                }
            };
        }
    }, [
        callback,
        mediaQuery
    ]);
}
